import React, { useEffect, useState, useRef } from 'react';
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCourseById, getCourseVideo } from "../../store/courseSlice";
import SideBar from './components/SideBar';
import Overview from './components/Overview';
import QAA from './components/QAA';
import Seminars from './components/Seminars';
import Certification from './components/Certification';
import useWindowWidth from "../../ui/hooks/useWindowWidth";

const PassingCourse = () => {
    const [activeTab, setActiveTab] = useState('Overview');
    const [showVideo, setShowVideo] = useState(false);
    const [video, setVideo] = useState(null);
    const videoRef = useRef(null);
    const width = useWindowWidth()
    const handleTabClick = (tab) => setActiveTab(tab);

    const { id } = useParams();
    const dispatch = useDispatch();
    const { course, videoUrl, loading } = useSelector((state) => state.courses);
    const [idTopic,setIdTopic] = useState([])
    useEffect(() => {
        if (id) dispatch(getCourseById(id));
        return () => setShowVideo(false);
    }, [dispatch, id]);

    const show = () => {
        setShowVideo(true);
    };

    const changeVideo = (newUrl) => {
        if (videoRef.current) {
            videoRef.current.pause(); // Останавливаем текущее видео
            videoRef.current.src = newUrl; // Устанавливаем новый источник
            videoRef.current.load(); // Перезагружаем видео
            videoRef.current.play().catch((error) => console.error("Ошибка при воспроизведении:", error));
        }
        setVideo(newUrl);
    };
    const changeIdTopic = (newUrl) => {
        setIdTopic(newUrl);
    };
    return (
        <div className='pb-[100px]'>
            <div className='lg:flex sm:flex'>
                <div className='w-[100%]'>
                    <div className='w-[100%]'>
                        {
                            idTopic.video ? <video ref={videoRef} width="100%" height="auto" autoPlay controls className='w-full object-cover pb-5'>
                                <source src={video} type="video/mp4" />
                                Ваш браузер не поддерживает видео.
                            </video> : <div className='flex justify-center bg-black'>
                                <iframe src={idTopic.material} width={width < 500? "100%" : "55%" } height="700px">Open</iframe>
                            </div>
                        }
                    </div>
                    <div className='w-[100%] sm:w-[65%]'>
                        <div className='lg:flex sm:flex items-center justify-between py-2 h-[85px] sm:h-[60px]'>
                            <div
                                className='flex justify-around sm:gap-5 items-center mb-3 text-sm sm:text-base shadow-lg sm:shadow-none px-0 sm:px-8 pb-0 sm:pb-0'>
                                {
                                    width < 500 && <button
                                        className={`pb-2 ${activeTab === 'Sidebar' ? 'border-b-2 border-black' : 'opacity-80'}`}
                                        onClick={() => handleTabClick('Sidebar')}>
                                        Inaugural lecture
                                    </button>
                                }
                                <button
                                    className={`pb-2 ${activeTab === 'Overview' ? 'border-b-2 border-black' : 'opacity-80'}`}
                                    onClick={() => handleTabClick('Overview')}>
                                    Overview
                                </button>
                                <button className={`pb-2 ${activeTab === 'QAA' ? 'border-b-2 border-black' : 'opacity-80'}`}
                                        onClick={() => handleTabClick('QAA')}>
                                    Questions and Answers
                                </button>
                            </div>
                            <div className='flex gap-5 justify-end sm:justify-start px-8'>
                                <button
                                    className={`px-5 py-1 bg-[#8C1C1C] text-[#FFF] rounded-xl ${activeTab === 'Seminars' ? 'bg-[#402D1D]' : 'bg-[#BA7373]'}`} onClick={() => handleTabClick('Seminars')}>
                                    Seminars
                                </button>
                                <button className={`px-5 py-1 bg-[#8C1C1C] text-[#FFF] rounded-xl ${activeTab === 'Certification' ? 'bg-[#402D1D]' : 'bg-[#BA7373]'}`} onClick={() => handleTabClick('Certification')}>
                                    Certification
                                </button>
                            </div>
                        </div>

                        <div className='px-8'>
                            {activeTab === 'Overview' && <Overview course={course} /> }
                            {activeTab === 'Sidebar' && width < 500 ? <SideBar setVideo={changeVideo} setIdTopic={changeIdTopic}/> : ""}
                            {activeTab === 'QAA' && <QAA item={idTopic}/>}
                            {activeTab === 'Seminars' && <Seminars />}
                            {activeTab === 'Certification' && <Certification />}
                        </div>
                    </div>
                </div>
                <div className="hidden sm:block w-[30%]">
                    <SideBar video={video} setVideo={changeVideo} setIdTopic={changeIdTopic}/>
                </div>
            </div>


        </div>
    );
};

export default PassingCourse;
